import { AccountsService } from 'base/accounts_service';
import { ToastQueue } from 'base/ui/toast';

export function showPaymentProblemToast(
  accountsService: AccountsService,
  toastQueue: ToastQueue,
) {
  const promise = accountsService.createStripeBillingSession({
    preferInvoice: true,
  });
  let billingUrl: string | undefined;
  promise.then(({ url }) => (billingUrl = url));

  return toastQueue.addPersistent(() => ({
    label: 'Update your billing details to regain access to premium features',
    action: {
      label: 'Fix Payment',
      onClick: () => {
        if (billingUrl) {
          // popups might be blocked by the await, so we prefer to not await
          window.open(billingUrl, '_blank');
        } else {
          promise.then(({ url }) => {
            window.open(url, '_blank');
          });
        }
      },
    },
  }));
}
